import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/**
 * ToLink Pipe
 * find Links in text and return a clickable a tag
 * */
@Pipe({
  name: 'toLink',
})
export class ToLinkPipe implements PipeTransform {

  constructor(private sanitize: DomSanitizer) {
  }

  transform(value: any, linkLabel: string = '', linkIdentifiers: string[] | RegExp[] = [/https?:\/\/\S+/gm],
            rawValue: any): any {
    if (!value || (typeof value !== 'string')) {
      return value;
    }
    return this.textToLinks(rawValue, linkLabel, linkIdentifiers, value);
  }

  private textToLinks(value: string, linkLabel: string, linkIdentifiers: string[] | RegExp[], originalValue: any): SafeHtml {
    if (typeof value === 'string') {
      let formattedText = value;
      linkIdentifiers.forEach(item => {
        formattedText = formattedText.replace(item,
          (m, $1) => `<a onclick="event.stopPropagation()" target="_blank" style="text-decoration: none;" href="${m}" title="${m}">${linkLabel || m}</a>`);
      });
      if (formattedText !== value) {
        return this.sanitize.bypassSecurityTrustHtml(formattedText);
      }
      return originalValue;
    }
    // as the pipe is the last step in editing values, if nothing changes its better to return original value
    return originalValue;
  }
}
